import React, { useEffect, useState } from "react";
import { useStyles } from "../../assets/jss/AnalyticsExports";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomButton from "../CustomComponents/CustomButton/CustomButton";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import DateTime from "../DateTime/DateTime";
import { getStartDate, getEndDate } from "../../services/LocalStorageService";
import {
  getReportsList,
  getDownloadReport,
} from "../../services/GetReportsList";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import ReportDownload from "../../assets/images/reportDownload.png";
import trackEvents from "../../assets/appInsightsEvents";
import clsx from "clsx";
import CustomSkeleton from "../CustomComponents/CustomSkeleton/CustomSkeleton";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import reportBg from "../../assets/images/downloadReportBg.png";
import billableReportBg from "../../assets/images/billable_report_bg.png";
import tripReportBg from "../../assets/images/trip_report_bg.png";
import { ReportCode } from "../../config/app-globals.enum";

export default function EngagementReport(props) {
  const params = useParams();
  const { t } = useTranslation();
  const classes = useStyles();
  const [startDate] = React.useState(getStartDate);
  const [endDate] = React.useState(getEndDate);
  const [reportList, setReportList] = useState(null);
  const [reportCode, setReportCode] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const [statusValue, setStatusValue] = React.useState();
  const [isApiFailed, setIsApiFailed] = useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [isAlertOpen, setIsAlertOpen] = React.useState(false);
  const changeApiStatusCodeFunc = (status) => {
    if (status.code && status.code !== 0 && status.code !== 200) {
      setStatusValue(status.code);
      setAlertMessage(
        status.message
          ? status.message
          : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
      );
      setIsAlertOpen(true);
    }
  };

  async function loadData() {
    setStatusValue(null);
    setAlertMessage("");
    setIsAlertOpen(false);
    const data = await getReportsList(params);
    if (
      (data.status.code === 0 ||
        data.status.code === 200 ||
        data.status.code === 201) &&
      data.content
    ) {
      setReportList(data.content);
      setIsApiFailed(false);
    } else {
      setIsApiFailed(true);
      changeApiStatusCodeFunc(data.status);
    }
  }

  async function downloadData(reportData) {
    setStatusValue(null);
    setAlertMessage("");
    setIsAlertOpen(false);
    const data = await getDownloadReport(reportData.reportId, params);
    setIsDownloading(false);
    if (
      data &&
      (data.status.code === 0 ||
        data.status.code === 200 ||
        data.status.code === 201) &&
      data.content
    ) {
      try {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf("MSIE ");
        const fileName = reportData.reportName.replace(/ /g, "_");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
          // If Internet Explorer, return version number
          const IEwindow = window.open(
            "",
            "targetWindow",
            `
              toolbar=no,
              location=no,
              status=no,
              menubar=no,
              scrollbars=yes,
              resizable=yes,
              width=500,
              height=500
              `
          );
          IEwindow.document.write("sep=,\r\n" + data.content);
          IEwindow.document.close();
          IEwindow.document.execCommand("SaveAs", true, fileName + ".csv");
          IEwindow.close();
        } else {
          const reportUrl =
            "data:text/csv;charset=utf-8," + escape(data.content);
          const link = document.createElement("a");
          link.href = reportUrl;
          //link.style = "visibility:hidden";
          link.download = fileName + ".csv";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      changeApiStatusCodeFunc(data.status);
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  const downloadRoprtLinkClick = (reportData) => {
    trackEvents("Download Engagement Report(Export)", {}, params);
    setReportCode(reportData.reportCode);
    setIsDownloading(true);
    downloadData(reportData);
  };

  return (
    <>
      <CustomGrid container spacing={4}>
        <CustomGrid item xs={12}>
          {reportList && reportList.length === 0 && (
            <CustomPaper square elevation={0} className={classes.exportCard}>
              <CustomCard elevation={0} className={classes.exportCardWrapper}>
                <CustomCardContent
                  className={classes.exportCardContentLoader}
                  style={{ padding: "1.5em 3em" }}
                >
                  {t("NO_REPORT_FOUND_TO_DOWNLOAD")}
                </CustomCardContent>
              </CustomCard>
            </CustomPaper>
          )}
          {!isApiFailed ? (
            <>
              {reportList && reportList.length ? (
                reportList.map((report, index) => {
                  return (
                    <CustomPaper
                      key={`reportItem-${index}`}
                      square
                      elevation={0}
                      className={classes.exportCard}
                    >
                      <CustomCard
                        elevation={0}
                        className={classes.exportCardWrapper}
                      >
                        <CustomCardContent
                          className={classes.exportCardContent}
                        >
                          <CustomBox className={classes.exportCardTitle}>
                            {t(`REPORT_${report.reportCode}_TITLE`)}
                          </CustomBox>
                          <CustomBox className={classes.exportCardDate}>
                            <DateTime
                              inputDate={report.reportFromDate}
                              returnFormat="DD MMM"
                            />{" "}
                            -{" "}
                            <DateTime
                              inputDate={report.reportToDate}
                              returnFormat="DD MMM"
                            />
                            ,{" "}
                            <DateTime
                              inputDate={report.reportToDate}
                              returnFormat="YYYY"
                            />
                          </CustomBox>
                          <CustomBox className={classes.exportCardText}>
                            {t(`REPORT_${report.reportCode}_DESCRIPTION`)}
                          </CustomBox>
                          <CustomBox className={classes.exportCardLink}>
                            <CustomButton
                              variant="contained"
                              color="primary"
                              disabled={report.reportCode === reportCode && isDownloading ? isDownloading : false}
                              defaultrounded="true"
                              className={clsx(
                                classes.exportCardButton,
                                isApiFailed
                                  ? classes.exportCardButtonDisabled
                                  : null
                              )}
                              onClick={() => downloadRoprtLinkClick(report)}
                            >
                              <img
                                className={classes.downloadIcon}
                                src={ReportDownload}
                                alt=""
                              />
                              {t("DOWNLOAD_REPORT")}
                              {isDownloading && report.reportCode == reportCode && (
                                <CustomCircularProgress
                                  className={classes.downloadSpinnerIcon}
                                />
                              )}
                            </CustomButton>
                          </CustomBox>
                        </CustomCardContent>
                        <CustomCardContent className={classes.exportCardImg} style={report.reportCode === ReportCode.ENGAGEMENT_REPORT ? { backgroundImage: `url(${reportBg})` } : report.reportCode === ReportCode.BILLABLE_REPORT ? { backgroundImage: `url(${billableReportBg})` } : { backgroundImage: `url(${tripReportBg})` }}>
                          <CustomBox className={classes.exportCardImgTitle}>
                            {t(`REPORT_${report.reportCode}_TITLE`)}
                          </CustomBox>
                          <CustomBox className={classes.exportCardImgDate}>
                            <DateTime
                              inputDate={report.reportFromDate}
                              returnFormat="DD MMM"
                            />{" "}
                            -{" "}
                            <DateTime
                              inputDate={report.reportToDate}
                              returnFormat="DD MMM"
                            />
                            ,{" "}
                            <DateTime inputDate={report.reportToDate} returnFormat="YYYY" />
                          </CustomBox>
                        </CustomCardContent>
                      </CustomCard>
                    </CustomPaper>
                  );
                })
              ) : (
                <CustomPaper
                  square
                  elevation={0}
                  className={classes.exportCard}
                >
                  <CustomCard
                    elevation={0}
                    className={classes.exportCardWrapper}
                  >
                    <CustomCardContent
                      className={classes.exportCardContentLoader}
                      style={{ padding: "1.5em 3em" }}
                    >
                      <CustomCircularProgress />
                    </CustomCardContent>
                  </CustomCard>
                </CustomPaper>
              )}
            </>
          ) : (
            <>
              <CustomPaper square elevation={0} className={classes.exportCard}>
                <CustomCard elevation={0} className={classes.exportCardWrapper}>
                  <CustomCardContent className={classes.exportCardContent}>
                    <CustomBox className={classes.exportCardTitle}>
                      <CustomSkeleton
                        animation="wave"
                        width={250}
                        height={50}
                      />
                    </CustomBox>
                    <CustomBox className={classes.exportCardDate}>
                      <CustomSkeleton
                        animation="wave"
                        width={100}
                        height={30}
                      />
                    </CustomBox>
                    <CustomBox className={classes.exportCardText}>
                      <CustomSkeleton
                        animation="wave"
                        width="100%"
                        height={20}
                      />
                      <CustomSkeleton
                        animation="wave"
                        width="70%"
                        height={20}
                      />
                      <CustomSkeleton
                        animation="wave"
                        width="85%"
                        height={20}
                      />
                      <CustomSkeleton
                        animation="wave"
                        width="45%"
                        height={20}
                      />
                    </CustomBox>
                    <CustomBox className={classes.exportCardLink}>
                      <CustomSkeleton
                        className={classes.btnSkeleton}
                        animation="wave"
                        width={170}
                        height={60}
                      />
                    </CustomBox>
                  </CustomCardContent>
                  <CustomCardContent className={classes.exportCardImg}>
                    <CustomBox className={classes.exportCardImgTitle}>
                      <CustomSkeleton
                        animation="wave"
                        width="100%"
                        height={70}
                      />
                    </CustomBox>
                    <CustomBox className={classes.exportCardImgDate}>
                      <CustomSkeleton
                        animation="wave"
                        width="70%"
                        height={30}
                      />
                    </CustomBox>
                  </CustomCardContent>
                </CustomCard>
              </CustomPaper>
            </>
          )}
        </CustomGrid>
      </CustomGrid>
      <ErrorAlert
        code={statusValue}
        message={alertMessage}
        isOpen={isAlertOpen}
        isClose={(isClose) => setIsAlertOpen(!isClose)}
      />
    </>
  );
}
